import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    //id: AutoId, optional // Mã tự sinh
    tour_id: null, //IdRef, required // Mã tour    
    huong_dan_vien_cho_xac_nhan_ids: [], //array of IdRef, optional // Danh sách mã hướng dẫn viên
    thoi_gian_bat_dau: null, //datetime, optional // Thời gian bắt đầu
    thoi_gian_ket_thuc: null, //datetime, optional // Thời gian kết thúc
    file_dinh_kem_ids: [], //array of IdRef, optional // Danh sách mã các file đính kèm
};

// validation form
model.validForm = {
    tour_id: [ValidService.requiredChange], //IdRef, required // Mã tour
    huong_dan_vien_cho_xac_nhan_ids: [ValidService.required], //array of IdRef, optional // Danh sách mã hướng dẫn viên
    thoi_gian_bat_dau: [ValidService.requiredChange], //datetime, optional // Thời gian bắt đầu
    thoi_gian_ket_thuc: [ValidService.requiredChange], //datetime, optional // Thời gian kết thúc
    file_dinh_kem_ids: [], //array of IdRef, optional // Danh sách mã các file đính kèm
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.   tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_gian_bat_dau", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            tour_id: "",
            huong_dan_vien_ids: "",
            thoi_gian_bat_dau: "",
            thoi_gian_ket_thuc: ""
        },
        valid: {
            tour_id: [],
            huong_dan_vien_ids: [],
            thoi_gian_bat_dau: [],
            thoi_gian_ket_thuc: [],
        },
        operator: {
            // tour_id: "",
            // huong_dan_vien_ids: "",
            thoi_gian_bat_dau: ":in_that_day:",
            thoi_gian_ket_thuc: ":in_that_day:"

        }
    }
};


export default model;